import React from 'react';
import { Box, Typography } from '@material-ui/core';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';

import ChildrenQtySelect from './ChildrenQtySelect';

import styles from "./styles";
import { useTranslation } from 'react-i18next';

export const DesiredChildrenQty = props => {
    const classes = styles();
    const { t } = useTranslation();

    return (
        <>
            <Box className={classes.iconSection}>
                <GpsFixedIcon className={classes.icon} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('fpqQuestionnaire.desiredChildrenQuestion')}
                </Typography>
            </Box>
            <Box className={classes.inputSection}>
                <ChildrenQtySelect value={props.value} onQtyChange={props.onChildrenQtyChange} />
            </Box>
        </>
    );
};

export default DesiredChildrenQty;